import { Grid, Stack } from "@mui/material";
import Card2 from "components/elements/Card2";
import SectionCard from "components/elements/SectionCard";
import { useMUIThemeModeContext } from "context/MUIThemeModeContext";
import { useTranslation } from "react-i18next";

import Atlas from "./Atlas";
import Discord, { Card2Gradient } from "./Discord";
import Trezor from "./Trezor";

const ProBenefitsAndCommunity = () => {
  const { t } = useTranslation();

  const { colors } = useMUIThemeModeContext();

  return (
    <SectionCard title={t("dashboard.proBenefitsAndCommunity.title")} id={"podporovatele"}>
      <Grid container spacing={3}>
        <Grid item xs={12} lg={6}>
          <Card2 borderRadius={8}>
            <Discord />
          </Card2>
        </Grid>
        <Grid item xs={12} lg={6}>
          <Card2Gradient borderRadius={8} background={colors.deepMidnightBlue}>
            <Stack spacing={{ xs: 2, md: 4 }}>
              <Atlas />
              <Trezor />
            </Stack>
          </Card2Gradient>
        </Grid>
      </Grid>
    </SectionCard>
  );
};

export default ProBenefitsAndCommunity;
